import uiString from "./string.json";
import * as XLSX from "xlsx";
import Papa from "papaparse";

export const initialQueryContent = {
  title: uiString.textFields.noSelection,
  description: uiString.textFields.noSelection,
  base_query: uiString.textFields.noSelection,
  employees: [],
  departments: [],
  approval_result: "",
  start_date: "",
  end_date: "",
  publish: 0
};

export const queryContentReducer = (state, action) => {
  switch (action.type) {
    case "title":
      return {
        ...state,
        title: action.title
      };
    case "description":
      return {
        ...state,
        description: action.description
      };
    case "base_query":
      return {
        ...state,
        base_query: action.base_query
      };
    case "employees":
      return {
        ...state,
        employees: action.employees
      };
    case "departments":
      return {
        ...state,
        departments: action.departments
      };
    case "approval_result":
      return {
        ...state,
        approval_result: action.approval_result
      };
    case "start_date":
      return {
        ...state,
        start_date: action.start_date
      };
    case "end_date":
      return {
        ...state,
        end_date: action.end_date
      };
    case "publish":
      return {
        ...state,
        publish: action.publish
      };
    default:
      throw new Error();
  }
};

const keepOnlyColumns = (csvData, columnsToKeep) => {
  // CSV 문자열을 파싱
  const parsed = Papa.parse(csvData, { header: true });

  // 데이터에서 지정된 컬럼만 유지
  const filteredData = parsed.data.map(row => {
    const newRow = {};
    columnsToKeep.forEach(column => {
      if (column in row) {
        newRow[column] = row[column];
      }
    });
    return newRow;
  });

  // CSV로 다시 변환
  return Papa.unparse(filteredData);
};

// columnsToKeep 인자가 있으면 해당 컬럼만 유지하고 엑셀 다운로드
// 비어있는 배열이면 기존대로 출력
export const downloadFileFromServer = (
  csvData,
  filename,
  columnsToKeep = []
) => {
  if (columnsToKeep.length > 0) {
    csvData = keepOnlyColumns(csvData, columnsToKeep);
  }

  const parsedData = Papa.parse(csvData, {
    skipEmptyLines: true
  }).data;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(parsedData);

  const timeRegex = /^([0-9]{1,3}):([0-5][0-9])$/;
  const wonRegex = /^₩\s*([0-9,]+)$/;

  for (let cell in ws) {
    if (cell[0] === "!") continue;

    const timeMatch = timeRegex.exec(ws[cell].v);
    const wonMatch = wonRegex.exec(ws[cell].v);

    if (timeMatch) {
      const hours = parseInt(timeMatch[1]);
      const minutes = parseInt(timeMatch[2]);
      ws[cell].v = hours / 24 + minutes / 1440;
      ws[cell].t = "n";
      ws[cell].z = "[h]:mm";
    } else if (wonMatch) {
      ws[cell].v = Number(wonMatch[1].replace(/,/g, ""));
      ws[cell].t = "n";
      ws[cell].z = '_-* #,##0_-;-* #,##0_-;_-* "-"_-;_-@_-';
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename + ".xlsx");
  } else {
    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = filename + ".xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
